export default __webpack_public_path__ + "static/char-s-39-zh-Hant-fa75342f4c438048c7b949cbdac3f689.webp";